import gql from 'graphql-tag';

export const sendPDF = gql`
  mutation($email: EmailInput!) {
    sendPDF(email: $email) {
      success
      errors
    }
  }
`;

export const incrementVisitCount = gql`
  mutation {
    incrementVisitCount
  }
`;
